import { PDPExpressCheckout } from 'src/featureFlags/featureFlags';
import type { ReduxApplicationState } from '../combinedReducer';

export const selectUser = (state: ReduxApplicationState) => state.user;

export const selectIsExpressCheckoutEnabled = (state: ReduxApplicationState): boolean =>
  state.user.featureFlags?.[PDPExpressCheckout.NAME] === PDPExpressCheckout.VARIANT;
